import { useMemo, useState } from 'react';

export const useStateRef = <T>(value: T | null = null) => {
  const [ref, setRef] = useState(value);
  const wrapRef = useMemo(() => ({ current: ref }), [ref]);
  return [ref, setRef, wrapRef] as const;
};
